import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { API } from "../lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sid = params.get("session_id");
    if (!sid) {
      navigate("/login");
      return;
    }
    fetch(`${API}/auth/session`, {
      method: "POST",
      headers: { "X-Session-ID": sid },
      credentials: "include",
    })
      .then((r) => {
        if (!r.ok) throw new Error("auth failed");
        return r.json();
      })
      .then((user) => {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user } });
      })
      .catch(() => navigate("/login"));
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--paper)]" data-testid="auth-callback">
      <Loader2 className="animate-spin text-[var(--petrol)]" size={40} />
    </div>
  );
}
